const EnablementState = {
  ENABLED: 'enabled',
  DISABLED: 'disabled',
}

export default EnablementState
